import React from "react";
import { QuotePersonData } from "../../types/home.types";

export interface QuoteSectionProps {
  quote: string;
  person: {
    name: string;
    role: string;
    company: string;
    imagePath: string;
  };
  backgroundColor?: string;
}

const QuoteSection: React.FC<QuoteSectionProps> = ({
  quote = "",
  person = {
    name: "",
    role: "",
    company: "",
    imagePath: "",
  },
  backgroundColor = "bg-orange-100 dark:bg-orange-800/20",
}) => {
  return (
    <div
      className={`flex flex-col md:flex-row rounded-xl shadow-sm overflow-hidden h-full items-center ${backgroundColor} px-3`}
    >
      {/* Left side - Person info */}
      <div className="md:w-1/3 p-5 flex flex-col items-center md:items-start">
        <div className="mb-4 w-[200px] h-auto overflow-hidden rounded-md mt-12">
          <img
            src={person.imagePath}
            alt={person.name}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="text-center md:text-left">
          <h3 className="font-madefor font-bold text-lg text-gray-800 dark:text-gray-100">
            {person.name}
          </h3>
          <p className="text-lg text-gray-600 dark:text-gray-400">
            {person.role} <br />
            {person.company}
          </p>
        </div>
      </div>

      {/* Right side - Quote */}
      <div className="md:w-2/3 p-5 flex items-center">
        <div className="font-petrona text-3xl md:text-5xl text-gray-700 dark:text-gray-100 px-6">
          “{quote}”
        </div>
      </div>
    </div>
  );
};

export default QuoteSection;
